module.exports = __webpack_public_path__ + "img/categoryOther.1ce166ad.svg";